import React from 'react';
import { Grid } from '@material-ui/core';

import useMobileDetect from 'Hooks/useMobileDetect';
import downloadAndroidImage from 'Images/download-mobile-app/download-android.png';
import downloadIOSImage from 'Images/download-mobile-app/download-ios.png';
import totangoLogoImage from 'Images/logo/tt-surge-square.png';

import './redirect-to-app-store.less';

const IOSLink = 'https://apps.apple.com/us/app/totango/id965309053';
const AndroidLink =
	'https://play.google.com/store/apps/details?id=com.totango.customersuccess&hl=en';

export default function RedirectToAppStore(props) {
	const { isAndroid } = useMobileDetect();
	const isAndroidOP = isAndroid();

	const renderAndroidDownload = () => (
		<a href={AndroidLink} className="redirect-box" target="__blank">
			<img src={downloadAndroidImage} alt="" />
		</a>
	);

	const renderIOSDownload = () => (
		<a href={IOSLink} className="redirect-box" target="__blank">
			<img src={downloadIOSImage} alt="" />
		</a>
	);

	return (
		<div className="redirect-container">
			<Grid
				container
				align="center"
				justifyContent="center"
				spacing={4}
				direction="column"
				className="redirect-container"
			>
				<Grid item>
					<img src={totangoLogoImage} className="totango-logo" alt="Totango" />
				</Grid>
				<Grid item>
					<div className="redirect-title">Download Totango App</div>
				</Grid>
				<Grid item className="redirect-description">
					Totango’s Customer Success application enables you to have all your valuable customer
					information available wherever you are.
				</Grid>
				<Grid item>
					<div className="redirect-item">
						{isAndroidOP ? renderAndroidDownload() : renderIOSDownload()}
					</div>
				</Grid>
			</Grid>
		</div>
	);
}
